import React, {
  Fragment,
  useEffect,
  useState,
} from "react";
import {
  Form,
  FormGroup,
  Input, Label,
  Button,
  FormFeedback
} from "reactstrap";
import { connect } from "react-redux";
import { clearUpdateProductError, updateProduct } from "../../store/products/actions";
import Message from "../../CommonData/Data/Message";
import { updateForm } from "../../store/form/actions";
import VWLoading from "../../components/vwLoading/vwLoading";

const EditProduct = (props) => {

  const { handleClose, errorMessage, form, isUpdatePending } = props;
  const [product, setProductDetails] = useState("");

  useEffect(() => {
    const { productDetails } = props;
    if (productDetails) {
      setProductDetails({ ...productDetails });
      props.updateForm({
        formEditProduct: { ...productDetails },
        errors: {}
      })
    }
    props.clearProductError();

    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };

  }, []);

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setProductDetails({ ...product, [name]: value });
    props.updateForm({
      formEditProduct: {
        ...form.formEditProduct,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });
  }

  const handleUpdateProduct = () => {
    const { formEditProduct } = form || {};
    const { productName } = formEditProduct || {};
    const currentErrors = {};

    if (!productName) {
      currentErrors.productName = "Product name is required"
    }

    props.updateForm({
      formEditProduct: {
        ...form.formEditProduct,
      },
      errors: currentErrors,
    })

    if (Object.keys(currentErrors).length === 0) {
      props.updateProduct(form.formEditProduct);
    }
  };

  return isUpdatePending ? (<VWLoading />) : (
    <Fragment>
      <Form onSubmit={handleUpdateProduct}>
        <FormGroup>
          {errorMessage && (
            <Message
              type="danger"
              defaultMessage={errorMessage}
              baseClassName="alert"
            />
          )}
          <Label>Product Name</Label><span className="text-danger">*</span>
          <Input
            autoFocus={true}
            type="text"
            name="productName"
            placeholder="Enter product name"
            onChange={handleInputChange}
            value={product.productName}
            invalid={form && form.errors && form.errors.productName}
          />
          <FormFeedback>{form && form.errors && form.errors.productName}</FormFeedback>
        </FormGroup>
        <div>
          <Button
            type="submit"
            className='me-4'
            color="success"
            onClick={handleUpdateProduct}
          >Update
          </Button>
          <Button
            type="button"
            color="danger"
            onClick={handleClose}
          >Cancel
          </Button>
        </div>
      </Form>

    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  form: state.form.form,
  isUpdatePending: state.products.isUpdatePending,
  errorMessage: state.products.updateProductError,
  productDetails: state.products.productDetails,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (editProductForm) => dispatch(updateForm(editProductForm)),
  updateProduct: (data) => dispatch(updateProduct(data)),
  clearProductError: () => dispatch(clearUpdateProductError()),
});


export default connect(mapStateToProps, mapDispatchToProps)(EditProduct);